import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Config from '../../../Config';
import { getWifiDataAsync } from './WifiManagementBlockAsyncThunk';

const initialState = {
    wifiFlowType: '',
    wifiNotInstalledText: '',
    joinServiceLink: '',
    routerNotAllowed: [],
    page: '',
    subscriber: {},
    errorDescription: '',
    networkWiFis:[], //original list
    optionalNetworks: []
};

const wifiManagementBlockSlice = createSlice({
    name: 'wifiManagementBlock',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.wifiFlowType = action.payload.wifiFlowType;
                state.wifiNotInstalledText = action.payload.wifiNotInstalledText;
                state.joinServiceLink = action.payload.joinServiceLink;
                state.routerNotAllowed = action.payload.routerNotAllowed;
            },
            prepare: (action) => {
                const currentBlock = action.wifiManagementBlock;
                const wifiFlowType = getWifiFlowType(currentBlock.wifiFlowType?.value);
                const wifiNotInstalledText = currentBlock.wifiNotInstalledText?.value;
                const joinServiceLink = currentBlock.joinServiceLink?.value;
                const routerNotAllowed = currentBlock.routerNotAllowed?.value || [];

                let page = 'subscribersPage';

                let payload = {
                    page: page,
                    wifiFlowType: wifiFlowType,
                    wifiNotInstalledText: wifiNotInstalledText,
                    joinServiceLink: joinServiceLink,
                    routerNotAllowed: routerNotAllowed
                };
                return { payload: payload };
            }
        },
        goToPage: (state, action) => {
            state.page = action.payload;
            window.scrollTo(0, 0);
        },
        setSubscriber: (state, action) => {
            state.subscriber = action.payload;
        },
        setOptionalNetworks: (state, action) => {
            state.optionalNetworks.map(function (item) {
                if (item.name == action.payload.name) {
                    item.isChecked = action.payload.isChecked;
                }
                return item;
            });
        },
        setErrorPage: (state, action) => {
            state.errorDescription = action.payload;
            state.page = 'errorPage';
        },
        reportDWH: (state, action) => { },
    },
    extraReducers: {
        [getWifiDataAsync.fulfilled]: (state, action) => {
            state.networkWiFis = action.payload.networkWiFis;
            //state.networkWiFis = action.payload.networkWiFis.splice(0, 1);
            state.optionalNetworks = action.payload.listFrequency?.map((item, index) => ({ name: item, isChecked: false }));
        },
    },
});


function getWifiFlowType(wifiFlowType) {
    if (!wifiFlowType) { return ''; }
    switch (wifiFlowType) {
        case 0: return '';
        case 1: return 'HOME_NETWORK';
        case 2: return 'GUEST_NETWORK';
        default: return '';
    }
}


export const {
    resetBlock,
    initBlock,
    goToPage,
    setSubscriber,
    setOptionalNetworks,
    setErrorPage,
    reportDWH
} = wifiManagementBlockSlice.actions;

export default wifiManagementBlockSlice.reducer;

